import script from "./OTabelaAcordeaoProjetos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaAcordeaoProjetos.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaAcordeaoProjetos.vue?vue&type=style&index=0&id=100db32d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100db32d"]])

export default __exports__